<template>
	<div class="onboarding">
		<transition name="fade">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
  export default {
    name: 'Layout'
  }
</script>

<style lang="scss">
    @import '../../../assets/sass/style';
</style>



// WEBPACK FOOTER //
// src/components/pages/Homepage/Layout.vue